import axios  from '../utils/axios'

// 获取觉得列表
export const getRolesList = function () {
    return axios.get('/role/getRoleList')
}

/*
* 获取角色列表
* id: 角色id
*/
export const getRoleAuthority = function (data: { id: number | null }) {
    return axios.post('/role/getRoleFunctionsById', data)
}
// 获取查看下的权限
export const getLevel5RoleFunctionsById = function (data: { roleId: number; id: number }) {
    return axios.get('/role/getLevel5RoleFunctionsById', { params: data })
}

/*
* 修改角色名称、新建角色
* name: 角色新名称
* id: 角色id，在新建角色的时候不需要
*/
export const setRoleName = function (data: { name: string; id?: number }) {
    return axios.post('/role/setRole', data)
}

/*
* 删除角色
* id: 角色id
*/
export const delRole = function (data: { id: number }) {
    return axios.delete('/role/delRole', { data: data })
}

/*
* 设置角色权限
* roleId: 角色id
* functionsIds: 权限数组
*/
export const setRoleFunctions = function (data: { roleId: number; functionsIds: Array<number> }) {
    return axios.post('/role/setRoleFunctions', data)
}

/*
* 获取还未设置角色的员工列表
* name: 员工姓名的筛选值
* page
* limit
*/
export const getNosettingList = function (data: { name?: string; page: number; limit: number }) {
    return axios.get('/user/noSetting', { params: data })
}

/*
* 设置员工角色
* userIds: 员工id
* roleID: 角色id
*/
export const setUserRole = function (data: { userIds: string[]; roleId: number | string }) {
    return axios.post('/user/setUserRole', data)
}

/*
* 获取设置了该角色的员工
* data: { page: number; limit: number; roleIds: number[] }
* roleIds: 获取数组中对应的角色id的员工，默认获取全部，放置全部的角色id
*/
export const getRoleUser = function (data: any) {
    return axios.post('/user/getUserByRoleId', data)
}
// 数据共享、转移左侧列表
export const getShareFunctionsList = function () {
    return axios.get('/role/getShareFunctionsList')
}
// 数据共享、转移列表
export const getRuleListByFunctionsId = function (data: {
    functionsId: number;
    limit: number;
    page: number;
    userId: string;
}) {
    return axios.get('/role/getRuleListByFunctionsId', {params:data})
}
// 数据转移新建规则
export const setNewRule = function (data: {
    id: number;  //数据共享/转移id（规则id） // 编辑时必须
    types: string;   // 规则类型 '0'-共享, '1'-转移
    functionsIdList: Array<number>; //功能id（数据内容）
    belongTo: string;  // 数据内容归属 '0'-部门, '1'-员工
    belongToId: string;  //用户id或者部门id
    userId: string;  //用户id（To Who）
    role: string; // 数据权限 '0'-编辑, '1'-仅读
}) {return axios.post('/role/setNewRule', data)}

// 停止运行、运行规则
export const setRuleById = function (data: { id: number; action: string }) {
    return axios.post('/role/setRuleById', data)
}
// 数据转移详情
export const getRuleById = function (id: number) {
    return axios.get('/role/getRuleById?id=' + id)
}
